import React from 'react';

const MilleniumFalcon = (props) => {

  const { radius, cells } = props;
  const width = 669 * (radius / 370); //radius;
  const height = 474 * (radius / 370); // radius;

  const base = cells[16].background;

  return (
    <svg width={`${width}px`} height={`${height}px`} x={-width / 2.14} y={-height * 1.4} viewBox="-3 -2 699 474" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
    <rect id="path-1" x="134" y="204" width="15" height="30"></rect>
    <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="15" height="30" fill="white">
    <use xlinkHref="#path-1"></use>
    </mask>
    <rect id="path-3" x="231" y="41" width="12" height="240"></rect>
    <mask id="mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="12" height="240" fill="white">
    <use xlinkHref="#path-3"></use>
    </mask>
    <rect id="path-5" x="255" y="41" width="12" height="121"></rect>
    <mask id="mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="12" height="121" fill="white">
    <use xlinkHref="#path-5"></use>
    </mask>
    <rect id="path-7" x="203" y="108" width="55" height="149"></rect>
    <mask id="mask-8" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="55" height="149" fill="white">
    <use xlinkHref="#path-7"></use>
    </mask>
    <rect id="path-9" x="188" y="264" width="22" height="55"></rect>
    <mask id="mask-10" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="22" height="55" fill="white">
    <use xlinkHref="#path-9"></use>
    </mask>
    <rect id="path-11" x="58" y="333" width="22" height="55"></rect>
    <mask id="mask-12" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="22" height="55" fill="white">
    <use xlinkHref="#path-11"></use>
    </mask>
    <rect id="path-13" x="192" y="273" width="13" height="46"></rect>
    <mask id="mask-14" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="46" fill="white">
    <use xlinkHref="#path-13"></use>
    </mask>
    <rect id="path-15" x="219" y="69" width="10" height="10"></rect>
    <mask id="mask-16" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="10" height="10" fill="white">
    <use xlinkHref="#path-15"></use>
    </mask>
    <rect id="path-17" x="219" y="85" width="10" height="10"></rect>
    <mask id="mask-18" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="10" height="10" fill="white">
    <use xlinkHref="#path-17"></use>
    </mask>
    <rect id="path-19" x="226" y="33" width="35" height="11"></rect>
    <mask id="mask-20" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="35" height="11" fill="white">
    <use xlinkHref="#path-19"></use>
    </mask>
    <rect id="path-21" x="490" y="206" width="15" height="30"></rect>
    <mask id="mask-22" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="15" height="30" fill="white">
    <use xlinkHref="#path-21"></use>
    </mask>
    <rect id="path-23" x="396" y="43" width="12" height="240"></rect>
    <mask id="mask-24" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="12" height="240" fill="white">
    <use xlinkHref="#path-23"></use>
    </mask>
    <rect id="path-25" x="372" y="43" width="12" height="121"></rect>
    <mask id="mask-26" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="12" height="121" fill="white">
    <use xlinkHref="#path-25"></use>
    </mask>
    <rect id="path-27" x="381" y="110" width="55" height="149"></rect>
    <mask id="mask-28" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="55" height="149" fill="white">
    <use xlinkHref="#path-27"></use>
    </mask>
    <rect id="path-29" x="429" y="266" width="22" height="55"></rect>
    <mask id="mask-30" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="22" height="55" fill="white">
    <use xlinkHref="#path-29"></use>
    </mask>
    <rect id="path-31" x="434" y="275" width="13" height="46"></rect>
    <mask id="mask-32" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="13" height="46" fill="white">
    <use xlinkHref="#path-31"></use>
    </mask>
    <rect id="path-33" x="410" y="87" width="10" height="10"></rect>
    <mask id="mask-34" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="10" height="10" fill="white">
    <use xlinkHref="#path-33"></use>
    </mask>
    <rect id="path-35" x="378" y="35" width="35" height="11"></rect>
    <mask id="mask-36" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="35" height="11" fill="white">
    <use xlinkHref="#path-35"></use>
    </mask>
    <rect id="path-37" x="598" y="354" width="96" height="15"></rect>
    <mask id="mask-38" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="96" height="15" fill="white">
    <use xlinkHref="#path-37"></use>
    </mask>
    <rect id="path-39" x="629" y="290" width="35" height="57"></rect>
    <mask id="mask-40" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="35" height="57" fill="white">
    <use xlinkHref="#path-39"></use>
    </mask>
    <rect id="path-41" x="619" y="272" width="55" height="15"></rect>
    <mask id="mask-42" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="55" height="15" fill="white">
    <use xlinkHref="#path-41"></use>
    </mask>
    <rect id="path-43" x="270" y="181" width="100" height="130"></rect>
    <mask id="mask-44" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="100" height="130" fill="white">
    <use xlinkHref="#path-43"></use>
    </mask>
    <rect id="path-45" x="303" y="189" width="35" height="68"></rect>
    <mask id="mask-46" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="35" height="68" fill="white">
    <use xlinkHref="#path-45"></use>
    </mask>
    <rect id="path-47" x="312" y="194" width="17" height="57"></rect>
    <mask id="mask-48" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="17" height="57" fill="white">
    <use xlinkHref="#path-47"></use>
    </mask>
    <rect id="path-49" x="343" y="194" width="10" height="90"></rect>
    <mask id="mask-50" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="10" height="90" fill="white">
    <use xlinkHref="#path-49"></use>
    </mask>
    <rect id="path-51" x="289" y="194" width="10" height="90"></rect>
    <mask id="mask-52" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="10" height="90" fill="white">
    <use xlinkHref="#path-51"></use>
    </mask>
    </defs>
    <g id="Group-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Group" stroke="#FFFFFF" fill={base}>
    <polygon id="Path-14" strokeWidth="3" points="70 350 233 9 251.027756 9 256 0 266 0 266 42.0475921 276 53 276 162.004587 263.958785 162.004587 257 174 257 308.182711"></polygon>
    <use id="Rectangle" mask="url(#mask-2)" strokeWidth="6" transform="translate(141.500000, 219.000000) rotate(26.000000) translate(-141.500000, -219.000000) " xlinkHref="#path-1"></use>
    <path d="M147,206 L228.000587,36.9987743" id="Path-15" strokeWidth="3"></path>
    <use id="Rectangle-7" mask="url(#mask-4)" strokeWidth="6" xlinkHref="#path-3"></use>
    <use id="Rectangle-7" mask="url(#mask-6)" strokeWidth="6" xlinkHref="#path-5"></use>
    <use id="Rectangle-7" mask="url(#mask-8)" strokeWidth="6" xlinkHref="#path-7"></use>
    <use id="Rectangle-7" mask="url(#mask-10)" strokeWidth="6" xlinkHref="#path-9"></use>
    <use id="Rectangle-7" mask="url(#mask-12)" strokeWidth="6" transform="translate(69.000000, 360.500000) rotate(112.000000) translate(-69.000000, -360.500000) " xlinkHref="#path-11"></use>
    <use id="Rectangle-7" mask="url(#mask-14)" strokeWidth="6" xlinkHref="#path-13"></use>
    <use id="Rectangle-3" mask="url(#mask-16)" strokeWidth="6" xlinkHref="#path-15"></use>
    <use id="Rectangle-3" mask="url(#mask-18)" strokeWidth="6" xlinkHref="#path-17"></use>
    <use id="Rectangle-2" mask="url(#mask-20)" strokeWidth="6" xlinkHref="#path-19"></use>
    <polyline id="Path-16" strokeWidth="3" points="92 343 104 307 158 259"></polyline>
    <polyline id="Path-17" strokeWidth="3" points="100 343 113 307 170 282"></polyline>
    <circle id="Oval-2" strokeWidth="3" cx="203.5" cy="169.5" r="27.5"></circle>
    <circle id="Oval-2" strokeWidth="3" cx="160.5" cy="263.5" r="27.5"></circle>
    <polygon id="Path-14" strokeWidth="3" transform="translate(466.000000, 177.000000) scale(-1, 1) translate(-466.000000, -177.000000) " points="363 352 526 11 544.027756 11 549 2 559 2 559 44.0475921 569 55 569 164.004587 556.958785 164.004587 550 176 550 310.182711"></polygon>
    <use id="Rectangle" mask="url(#mask-22)" strokeWidth="6" transform="translate(497.500000, 221.000000) scale(-1, 1) rotate(26.000000) translate(-497.500000, -221.000000) " xlinkHref="#path-21"></use>
    <path d="M410.999413,208 L492,38.9987743" id="Path-15" strokeWidth="3" transform="translate(451.499706, 123.499387) scale(-1, 1) translate(-451.499706, -123.499387) "></path>
    <use id="Rectangle-7" mask="url(#mask-24)" strokeWidth="6" transform="translate(402.000000, 163.000000) scale(-1, 1) translate(-402.000000, -163.000000) " xlinkHref="#path-23"></use>
    <use id="Rectangle-7" mask="url(#mask-26)" strokeWidth="6" transform="translate(378.000000, 103.500000) scale(-1, 1) translate(-378.000000, -103.500000) " xlinkHref="#path-25"></use>
    <use id="Rectangle-7" mask="url(#mask-28)" strokeWidth="6" transform="translate(408.500000, 184.500000) scale(-1, 1) translate(-408.500000, -184.500000) " xlinkHref="#path-27"></use>
    <use id="Rectangle-7" mask="url(#mask-30)" strokeWidth="6" transform="translate(440.000000, 293.500000) scale(-1, 1) translate(-440.000000, -293.500000) " xlinkHref="#path-29"></use>
    <use id="Rectangle-7" mask="url(#mask-32)" strokeWidth="6" transform="translate(440.500000, 298.000000) scale(-1, 1) translate(-440.500000, -298.000000) " xlinkHref="#path-31"></use>
    <use id="Rectangle-3" mask="url(#mask-34)" strokeWidth="6" transform="translate(415.000000, 92.000000) scale(-1, 1) translate(-415.000000, -92.000000) " xlinkHref="#path-33"></use>
    <use id="Rectangle-2" mask="url(#mask-36)" strokeWidth="6" transform="translate(395.500000, 40.500000) scale(-1, 1) translate(-395.500000, -40.500000) " xlinkHref="#path-35"></use>
    <polyline id="Path-18" strokeWidth="3" points="415 96 415 116 435 152 447.165525 152 447.165525 183.000442 461.036063 183.000442 474 216 493 208"></polyline>
    <polygon id="Path-19" strokeWidth="3" points="598 389 598 347.987807 620 287 620 274 674.147945 274 674.147945 288.025904 694 345 694 445.005 649 470 587 395"></polygon>
    <path d="M598,389 L694,446" id="Path-20" strokeWidth="3"></path>
    <use id="Rectangle-8" mask="url(#mask-38)" strokeWidth="6" xlinkHref="#path-37"></use>
    <use id="Rectangle-8" mask="url(#mask-40)" strokeWidth="6" xlinkHref="#path-39"></use>
    <use id="Rectangle-8" mask="url(#mask-42)" strokeWidth="6" xlinkHref="#path-41"></use>
    <circle id="Oval-2" strokeWidth="3" transform="translate(435.500000, 171.500000) scale(-1, 1) translate(-435.500000, -171.500000) " cx="435.5" cy="171.5" r="27.5"></circle>
    <circle id="Oval-2" strokeWidth="3" transform="translate(478.500000, 265.500000) scale(-1, 1) translate(-478.500000, -265.500000) " cx="478.5" cy="265.5" r="27.5"></circle>
    <path d="M570,351 L598,388" id="Path-21" strokeWidth="3"></path>
    <use id="Rectangle-9" mask="url(#mask-44)" strokeWidth="6" xlinkHref="#path-43"></use>
    <use id="Rectangle-9" mask="url(#mask-46)" strokeWidth="6" xlinkHref="#path-45"></use>
    <use id="Rectangle-9" mask="url(#mask-48)" strokeWidth="6" xlinkHref="#path-47"></use>
    <use id="Rectangle-9" mask="url(#mask-50)" strokeWidth="6" xlinkHref="#path-49"></use>
    <use id="Rectangle-9" mask="url(#mask-52)" strokeWidth="6" xlinkHref="#path-51"></use>
    <polygon id="Path-22" strokeWidth="3" points="0 470 77 312 558 312 648 469"></polygon>
    </g>
    </g>
    </svg>
  )
}

export function resize(props) {
  const {radius, minY} = props;
  const height = 556 * (radius / 620);

  return {
    ...props,
    minY: minY + height,
  }
}

export default MilleniumFalcon;


// WEBPACK FOOTER //
// ./src/core/thematic/millenium-falcon/index.js